var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveryProfiler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66677 4.99992V7.49992H4.16677V4.99992H6.66677ZM2.50011 3.33325V9.16658H8.33346V3.33325H2.50011ZM10.8335 3.33325H17.5001V4.99992H10.8335V3.33325ZM10.8335 9.16658H17.5001V10.8333H10.8335V9.16658ZM10.8335 14.9999H17.5001V16.6666H10.8335V14.9999ZM8.92271 13.5058L7.74418 12.3273L5.00011 15.0714L3.50602 13.5773L2.32751 14.7558L5.00011 17.4284L8.92271 13.5058Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveryProfiler);
export default __webpack_public_path__ + "static/media/survery_profiler.b9b2377fbf759a7d7f291dadb2aacb92.svg";
export { ForwardRef as ReactComponent };